import { useTranslation } from "@impero-com/common/utils/i18n";
import {
    TimeToDueDateFilter,
    timeToDueDateFilterSchema,
} from "@impero-com/ui/domain";
import { InputNumber, Select } from "antd";

export function TimeToDueDateFilterInputs({
    value,
    onChange: setValue,
}: {
    value: TimeToDueDateFilter;
    onChange: (value: TimeToDueDateFilter) => void;
}) {
    const { t } = useTranslation();
    const onChange = (next: TimeToDueDateFilter) => {
        if (timeToDueDateFilterSchema.safeParse(next).success) {
            setValue(next);
        }
    };
    const comparison = value.comparison;
    const comparisonSelect = (
        <Select
            aria-label={t("ControlActivitiesList_TimeToDueDate_Comparison")}
            value={comparison.type}
            onChange={(type: TimeToDueDateFilter["comparison"]["type"]) =>
                onChange({
                    ...value,
                    comparison: { type, value: comparison.value },
                })
            }
            options={[
                {
                    value: "atLeast",
                    label: t("ControlActivitiesList_TimeToDueDate_AtLeast"),
                },
                {
                    value: "atMost",
                    label: t("ControlActivitiesList_TimeToDueDate_AtMost"),
                },
            ]}
        />
    );
    const unitSelect = (
        <Select
            aria-label={t("ControlActivitiesList_TimeToDueDate_Unit")}
            value={value.unit}
            onChange={(unit: TimeToDueDateFilter["unit"]) =>
                onChange({ ...value, unit })
            }
            options={[
                {
                    value: "hours",
                    label: t("ControlActivitiesList_TimeToDueDate_HoursUnit"),
                },
                {
                    value: "days",
                    label: t("ControlActivitiesList_TimeToDueDate_DaysUnit"),
                },
            ]}
        />
    );
    return (
        <InputNumber
            addonBefore={comparisonSelect}
            addonAfter={unitSelect}
            aria-label={t("ControlActivitiesList_TimeToDueDate_Minimum")}
            min={0}
            max={1_000_000}
            precision={0}
            value={comparison.value}
            onChange={(number) => {
                if (number !== null) {
                    onChange({
                        ...value,
                        comparison: { ...comparison, value: number },
                    });
                }
            }}
        />
    );
}
